type AnyArray<T> = Extract<T, Readonly<unknown[]> | unknown[]>
export function isArray<T>(arr: T): arr is AnyArray<T> {
  return Array.isArray(arr)
}
export function keysOf<T extends {}>(object: T) {
  return Object.keys(object) as unknown as Extract<keyof T, string>[]
}

export function fromEntries<T extends string, V>(entries: [T, V][]): Record<T, V> {
  return Object.fromEntries(entries) as Record<T, V>
}

export type Entries<T> = Exclude<
  {
    [K in keyof T]: [K, T[K]]
  }[keyof T],
  undefined
>[]

export function entriesOf<T extends {}>(object: T) {
  return Object.entries(object) as Entries<T>
}

export function* range(max: number) {
  for (let n = 0; n < max; ++n) {
    yield n
  }
}
